@if (navbarState$ | async; as state) {
  @if (state.loggedIn && state.isOverviewer) {
    <app-side-nav-menu></app-side-nav-menu>
  }
  @if (!(state.loggedIn && state.isOverviewer) || !state.loggedIn) {
    <app-navbar></app-navbar>
  }
}
